
















































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { v4 as uuidv4 } from 'uuid';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {
  }
})
export default class VisitCap extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: {[type: string]: number} = {};

  enabled: {[type: string]: boolean} = {
    perHour:false,
    perDay:false,
    perMonth:false
  };

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.visitCap) {
      this.$set(this.conditions, 'visitCap', {
        id:uuidv4(),
        predicate: 'LOWER_OR_EQUALS',
        values: {}
      });
    }
  }

  @Watch('enabled',{deep:true})
  enabledPerHourChanged(enabled: any) {
    this.updateConditions()
  }
 
  
  @Watch('value',{deep:true})
  onValueChanged(newValue: {[type: string]: number}) {
    this.updateConditions()
  }
  
  updateConditions(){
    const cleanedValue=Object.entries(this.value).reduce((acc,[key,value]) => {
      if(value!==0 && this.enabled[key]){
        acc[key] = value;
      }
      return acc;
    },{});
    this.$set(this.conditions.visitCap, 'values', cleanedValue);
  }

  mounted() {
    this.value = this.conditions.visitCap.values;
    Object.keys(this.value).forEach((item=>{
      this.enabled[item] = !!this.value[item]
    }))
  }

}
